/**
 * Get value from local storage.
 * @param {string} key Key to get value
 * @returns {any|null}
 */
function get(key) {
  const stringValue = localStorage.getItem(key);
  return stringValue ? JSON.parse(stringValue) : null;
}

/**
 * Saves value to local storage.
 * @param {string} key Key to save value.
 * @param {any} value Secret to save.
 */
function save(key, value) {
  localStorage.setItem(key, JSON.stringify(value));
}

/**
 * Removes value from local storage.
 * @param {string} key Key to remove value.
 */
function remove(key) {
  localStorage.removeItem(key);
}

export const localStorageService = {
  get,
  save,
  remove,
};
